module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-right-square-warning-37ab42c9.svg";